import FinanceKeyObject from './finance-key-object';
window.$ = window.jQuery = require('jquery');

export default class extends FinanceKeyObject {
    constructor(vehicle) {
        super(vehicle);
        this.pseudoKey = 'HP';
        const key = 'HP';
        this.key = this.getActualKeyFromKey(key);
        this.name = this.getFinanceNameFromKey(vehicle, key);
        this.longName = this.name;
        this.order = (vehicle.brand == 'citroen') ? 2 : 4;
        this.defaultTerm = this.getDefaultTerm(vehicle.brand, key);
        this.defaultMileage = this.getDefaultMileage(vehicle.brand, key);
        this.mileage = false;
        this.alwaysShow = false;
        this.fallbackDeposit = {
            min: 0,
            max: Math.ceil((vehicle.price * 0.7) / 100) * 100,
        };
        this.fallbackTerms = [
            12,
            18,
            24,
            30,
            36,
            42,
            48,
            54,
            60,
        ];
        this.terms = [];
        this.fallbackMileages = [];

        this.termSlider = null;
        this.depositSlider = null;
    }

    getQuoteTitleValuePairs(quote) {
        if (quote.error == true) {
            return [];
        }

        let h = [];

        h.push({
            title: '<span class="term">' + quote.financeProduct.Quote.Term + '</span> Monthly Payments',
            emailTitle: quote.financeProduct.Quote.Term + ' Monthly Payments',
            value: '&pound;' + number_format(quote.getMonthlyPayment(),2)
        });

        h = this.appendVehiclePricingIncludingApplicableGrants(h, quote);

        h.push({
            title: 'Customer Deposit',
            value: '&pound;' + number_format(quote.financeProduct.Quote.CashDeposit,2),
        });

        let depCon = quote.getDepositContribution();

        if (depCon > 0) {
            h.push({
                title: this.brandName() + ' Deposit Contribution',
                value: '&pound;' + number_format(depCon,2),
            });
        }

        h.push({
            title: 'Total Amount Of Credit',
            value: '&pound;' + number_format(quote.financeProduct.Quote.Balance,2),
        });
        h.push({
            title: 'Term Of Agreement',
            value: quote.financeProduct.Quote.Term + ' months'
        });
        h.push({
            title: 'Total Charge For Credit',
            value: '&pound;' + number_format(quote.financeProduct.Quote.TotalChargeForCredit,2),
        });
        h.push({
            title: 'Total Amount Of Credit',
            value: '&pound;' + number_format(quote.financeProduct.Quote.AmountOfCredit,2),
        });
        h.push({
            title: 'Total Amount Payable',
            value: '&pound;' + number_format(quote.financeProduct.Quote.TotalAmountPayable,2),
        });

        if (this.isFinanceModified()) {
            h.push({
                title: 'APR',
                value: number_format(quote.financeProduct.Quote.Apr,2) + ' %'
            });
        }
        else {
            h.push({
                title: 'Representative APR',
                value: number_format(quote.financeProduct.Quote.Apr,2) + ' %'
            });
        }

        h.push({
            title: 'Fixed Rate of Interest',
            value: number_format(quote.financeProduct.Quote.RateOfInterest,2) + '%'
        });
        return h;
    }

    getRelevantCustomerParameters(customerParameters) {
        return [
            {
                title: 'Requested Finance',
                value: this.longName
            },
            {
                title: 'Requested Term',
                value: this.formatTerm(customerParameters.getTerm(this)),
            },
            {
                title: 'Requested Deposit',
                value: this.formatDeposit(customerParameters.getDeposit(this)),
            },
        ];
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/finance/finance-product-objects/hp.js